
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about",
      function () {
        return require("private-next-pages/about.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about"])
      });
    }
  